import React from 'react';
import { Link } from 'react-router-dom';

function CoursesPageHeader() {
  return (
    <header className="courses-header">
      <div className="courses-header-content">
        <Link to="/" className="courses-logo">
          <img src="/logo.png" alt="Pikly" />
          <span>PIKLY</span>
        </Link>
      </div>
    </header>
  );
}

export default CoursesPageHeader;
